import { HttpHandler } from 'msw'

import { createUserKonsole } from './createUserKonsole'
import { deleteUserKonsole } from './deleteUserKonsole'
import { getAllUsersKonsole } from './getAllUsersKonsole'
import { getUserKonsole } from './getUserKonsole'
import { updateUserKonsole } from './updateUserKonsole'

export const usersKonsole: HttpHandler[] = [
    createUserKonsole,
    deleteUserKonsole,
    getAllUsersKonsole,
    getUserKonsole,
    updateUserKonsole,
]
